import React, { useEffect, useState } from "react";
import { AiFillRightCircle, AiFillLeftCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import firebase from "../firebase";

const EventCard = ({ position, img, title, id }) => {
  return (
    <div
      // layout
      className={`${position} absolute mt-14 rounded-lg`}
      style={{ boxShadow: " 0px 10px 30px rgba(0,0,0,0.45) " }}
    >
      <img className="rounded-t-lg h-72 w-full" src={img} alt="imgAlt" />
      <div className="p-3 rounded-b-lg flex flex-col items-center justify-around font-bold text-white bg-gray-900">
        <span className="xl:text-2xl text-xl pb-3">{title}</span>
        <Link
          to={`/events/${id}`}
          className="text-lg font-bold rounded-full py-2 px-9 border-white border-solid border-2"
        >
          Show
        </Link>
      </div>
    </div>
  );
};

export default function Events() {
  const [webPos, setWebPos] = useState("active-img");
  const [androidPos, setAndroidPos] = useState("next small");
  const [cloudPos, setCloudPos] = useState("smaller prevSmall");
  const [aiPos, setAiPos] = useState("prev small");
  const [otherPos, setOtherPos] = useState("smaller nextSmall");
  const pos = [webPos, androidPos, cloudPos, aiPos, otherPos];

  const handleNextClick = () => {
    let nextMapping = {
      "active-img": "next small",
      "next small": "smaller nextSmall",
      "smaller nextSmall": "smaller prevSmall",
      "smaller prevSmall": "prev small",
      "prev small": "active-img",
    };
    setWebPos(nextMapping[webPos]);
    setAndroidPos(nextMapping[androidPos]);
    setCloudPos(nextMapping[cloudPos]);
    setAiPos(nextMapping[aiPos]);
    setOtherPos(nextMapping[otherPos]);
  };
  const handlePrevClick = () => {
    let prevMapping = {
      "smaller nextSmall": "next small",
      "smaller prevSmall": "smaller nextSmall",
      "prev small": "smaller prevSmall",
      "active-img": "prev small",
      "next small": "active-img",
    };
    setWebPos(prevMapping[webPos]);
    setAndroidPos(prevMapping[androidPos]);
    setCloudPos(prevMapping[cloudPos]);
    setAiPos(prevMapping[aiPos]);
    setOtherPos(prevMapping[otherPos]);
  };
  let [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const refTeams = firebase.firestore().collection("teams");
  function getTeams() {
    setLoading(!loading);
    refTeams
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setTeams(items);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getTeams();
  }, []);
  const items = [];
  teams = teams.filter((t) => t.id !== "ea69e77d-8f31-4a52-81fc-85cfd65ad49b");
  teams = teams.sort((a, b) =>
    a.id === "f9ca7c46-e77c-4cd3-bf99-8156ced478df" ? -1 : 1
  );
  for (let index = 0; index < teams.length; index++) {
    items.push(
      <EventCard
        key={index}
        position={pos[index]}
        title={teams[index].name}
        img={teams[index].profileImage}
        id={teams[index].id}
      />
    );
  }
  return (
    <div className="flex flex-col items-center justify-center h-screen -mt-20">
      <div className="relative lg:w-1/3 md:w-2/5 w-full h-56 m-auto scale-50 md:-scale-50">
        <AiFillLeftCircle
          className="prev-btn text-6xl dark:text-white cursor-pointer dark:hover:text-pink-700"
          onClick={handlePrevClick}
        >
          &lt;
        </AiFillLeftCircle>

        {items}

        {/* <EventCard position={webPos} title="Web Development" img={webImage} />
        <EventCard
          position={androidPos}
          title="Android Development"
          img={androidImage}
        />
        <EventCard
          position={cloudPos}
          title="Cloud Computing"
          img={cloudImage}
        />
        <EventCard
          position={aiPos}
          title="Artificial Intelligence"
          img={aiImage}
        />
        <EventCard position={otherPos} title="Others" img={aiImage} /> */}

        <AiFillRightCircle
          className="next-btn text-6xl dark:text-white cursor-pointer dark:hover:text-pink-700"
          onClick={handleNextClick}
          style={{ cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
